import React from "react";

export const ProgressRing = ({
  value = 0,
  size = 72,
  stroke = 6,
  color = "#6366F1",
  trackColor = "#F1F5F9",
  label,
  sublabel,
}) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (Math.min(Math.max(value, 0), 100) / 100) * circumference;

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={trackColor}
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference}`}
          style={{ transition: "stroke-dasharray 600ms ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {label !== undefined && (
          <span className="font-display font-bold text-slate-900" style={{ fontSize: size * 0.26 }}>
            {label}
          </span>
        )}
        {sublabel && <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500">{sublabel}</span>}
      </div>
    </div>
  );
};
